/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <ImagesLinks {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section, CmsImage } from "@bw/bits"
import { ImagesLinks as ImagesLinksModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components

const ImagesLinks = ({
  subtitle,
  suptitle,
  button,
  buttonPosition,
  backgroundVariant,
  ImagesLinks,
}) => {
  return (
    <Section
      {...{
        subtitle,
        suptitle,
        button,
        buttonPosition,
        backgroundVariant,
      }}
    >
      <ImagesLinksModule
        ImageLinks={ImagesLinks.map(ImageLink => ({
          ...ImageLink,
          entry: ImageLink.entry?.url,
          image: (
            <CmsImage
              src={ImageLink.image}
              alt={ImageLink.image?.alt || ImageLink.title}
            />
          ),
        }))}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ImagesLinksModule {
 *   ...ImagesLinksModuleFragment
 * }
 *
 * This is also what you will get in the props of your ImagesLinks
 * resolver component.
 */
export const query = graphql`
  fragment ImagesLinksModuleFragment on ImagesLinksModule {
    ImagesLinks {
      entry {
        id
        url
      }
      title
      image {
        alt
        localImage {
          childImageSharp {
            gatsbyImageData(width: 420)
          }
        }
      }
    }
  }
`

export { ImagesLinks }
